var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVersatile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F7F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 28.6667H28.3333C28.687 28.6667 29.0261 28.5262 29.2761 28.2761C29.5262 28.0261 29.6667 27.687 29.6667 27.3333V19.3333C29.6667 18.9797 29.5262 18.6406 29.2761 18.3905C29.0261 18.1405 28.687 18 28.3333 18H20.3333C19.9797 18 19.6406 18.1405 19.3905 18.3905C19.1405 18.6406 19 18.9797 19 19.3333V27.3333C19 27.687 19.1405 28.0261 19.3905 28.2761C19.6406 28.5262 19.9797 28.6667 20.3333 28.6667ZM21.6667 20.6667H27V26H21.6667V20.6667ZM41.6667 18H33.6667C33.313 18 32.9739 18.1405 32.7239 18.3905C32.4738 18.6406 32.3333 18.9797 32.3333 19.3333V27.3333C32.3333 27.687 32.4738 28.0261 32.7239 28.2761C32.9739 28.5262 33.313 28.6667 33.6667 28.6667H41.6667C42.0203 28.6667 42.3594 28.5262 42.6095 28.2761C42.8595 28.0261 43 27.687 43 27.3333V19.3333C43 18.9797 42.8595 18.6406 42.6095 18.3905C42.3594 18.1405 42.0203 18 41.6667 18ZM40.3333 26H35V20.6667H40.3333V26ZM28.3333 42C28.687 42 29.0261 41.8595 29.2761 41.6095C29.5262 41.3594 29.6667 41.0203 29.6667 40.6667V32.6667C29.6667 32.313 29.5262 31.9739 29.2761 31.7239C29.0261 31.4738 28.687 31.3333 28.3333 31.3333H20.3333C19.9797 31.3333 19.6406 31.4738 19.3905 31.7239C19.1405 31.9739 19 32.313 19 32.6667V40.6667C19 41.0203 19.1405 41.3594 19.3905 41.6095C19.6406 41.8595 19.9797 42 20.3333 42H28.3333ZM21.6667 34H27V39.3333H21.6667V34ZM39 32.6667H36.3333V35.3333H33.6667V38H36.3333V40.6667H39V38H41.6667V35.3333H39V32.6667Z",
    fill: "#0516C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersatile);
export default __webpack_public_path__ + "static/media/versatile.c81d27fd0c3323a019cd4694fef25bd2.svg";
export { ForwardRef as ReactComponent };